(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chronoera-homepage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('chronoera-bestseller-tabs')) {
  customElements.define('chronoera-bestseller-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const select = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab), { signal: this.controller.signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next], true);
        }, { signal: this.controller.signal });
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chronoera-product-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('chronoera-product-details')) {
  class ChronoeraProductDetails extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const source = this.querySelector('.ch-pdp-description');
      const table = this.querySelector('.ch-pdp-spec-table');
      if (!table?.tBodies[0]?.rows.length) this.querySelector('.ch-pdp-specifications')?.setAttribute('hidden', '');
      if (!source || !table || !/^(en|lv|lt)(-|$)/.test(this.dataset.language || '')) return;
      try {
        this.organize(source, table);
      } catch {
        this.dataset.layout = 'original';
      }
    }

    textLines(node) {
      const clone = node.cloneNode(true);
      clone.querySelectorAll('br').forEach(el => el.replaceWith('\n'));
      clone.querySelectorAll('p,li,div,section,tr').forEach(el => el.append('\n'));
      return clone.textContent.split('\n').map(text => text.replace(/^[\s•·]+/, '').replace(/\s+/g, ' ').trim()).filter(Boolean);
    }

    organize(source, table) {
      const copy = source.cloneNode(true);
      const normalize = text => text.replace(/\s+/g, ' ').trim().toLowerCase().replace(/[’‘]/g, "'");
      const firstParagraph = copy.querySelector('p');
      if (![...copy.querySelectorAll('h1,h2,h3,h4,h5,h6,p,strong')].some(el => /^(specifications|specifikācijas|specifikācija|techninės charakteristikos|specifikacijos):?$/.test(normalize(el.textContent))) && firstParagraph && /^(case diameter|diameter|korpusa diametrs|diametrs|korpuso skersmuo|skersmuo):/i.test(firstParagraph.textContent.trim()) && firstParagraph.querySelectorAll('br').length >= 2) {
        const marker = document.createElement('h2');
        marker.textContent = 'Specifications';
        firstParagraph.before(marker);
      }
      const headingNodes = [...copy.querySelectorAll('h1,h2,h3,h4,h5,h6,p,strong')];
      const heading = headingNodes.find(el => /^(specifications|specifikācijas|specifikācija|techninės charakteristikos|specifikacijos):?$/.test(normalize(el.textContent)));
      if (!heading) return;
      const nextHeading = headingNodes.find(el => el !== heading && heading.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING && (/^h[1-6]$/i.test(el.tagName) || /^(why you(?:'ll| will) like it|description|additional information|apraksts|kāpēc izvēlēties šo modeli|papildu informācija|aprašymas|papildoma informacija):?$/.test(normalize(el.textContent))));

      const range = document.createRange();
      range.setStartAfter(heading);
      if (nextHeading) range.setEndBefore(nextHeading);
      else range.setEnd(copy, copy.childNodes.length);
      const specs = document.createElement('div');
      specs.append(range.cloneContents());
      if (specs.querySelector('img,video,iframe,a,table')) return;
      const lines = this.textLines(specs);
      if (lines.length < 2 || lines.length > 60 || lines.some(line => line.length > 500)) return;
      const labels = Object.fromEntries([...table.tBodies[0].rows].map(row => [row.dataset.specKey, row.cells[0].textContent.trim()]));
      Object.assign(labels, JSON.parse(this.querySelector('[data-spec-labels]').textContent));
      const rows = new Map();
      const add = (key, label, value) => {
        if (!value) return;
        if (rows.has(key)) {
          if (!rows.get(key).values.includes(value)) rows.get(key).values.push(value);
        } else rows.set(key, { label, values: [value] });
      };
      const fallback = [...table.tBodies[0].rows].map(row => ({ key: row.dataset.specKey, label: row.cells[0].textContent.trim(), value: row.cells[1].textContent.trim() }));
      fallback.filter(row => ['brand', 'reference'].includes(row.key)).forEach(row => add(row.key, row.label, row.value));
      const keyMap = { 'skersmuo': 'case_size', 'korpuso skersmuo': 'case_size', 'storis': 'thickness', 'korpuso storis': 'thickness', 'atsparumas vandeniui': 'water_resistance', 'mechanizmas': 'movement', 'ciferblato spalva': 'dial_color', 'modelio numeris': 'reference', 'modelio kodas': 'reference', 'diametrs': 'case_size', 'korpusa diametrs': 'case_size', 'biezums': 'thickness', 'korpusa biezums': 'thickness', 'ūdensizturība': 'water_resistance', 'mehānisms': 'movement', 'ciparnīcas krāsa': 'dial_color', 'modeļa numurs': 'reference', diameter: 'case_size', 'case diameter': 'case_size', 'case size': 'case_size', thickness: 'thickness', 'case thickness': 'thickness', 'water resistance': 'water_resistance', movement: 'movement', 'dial colour': 'dial_color', 'dial color': 'dial_color', 'band colour': 'band', 'band color': 'band', reference: 'reference' };
      for (const line of lines) {
        const colon = line.indexOf(':');
        if (colon > 0 && colon < 55 && line.slice(colon + 1).trim()) {
          const rawLabel = line.slice(0, colon).trim();
          const key = keyMap[normalize(rawLabel)] || normalize(rawLabel);
          add(key, labels[key] || rawLabel, line.slice(colon + 1).trim());
          continue;
        }
        let key = 'featuress';
        if (/case\s*back|aizmugur.*vāk|galinis.*dangtel|galin.*dangtel/i.test(line)) key = 'case_back';
        else if (/\bclasp\b|aizdar|užseg|sagt/i.test(line)) key = 'clasp';
        else if (/\bcrown\b|kronīt|karūnėl/i.test(line)) key = 'crown';
        else if (/\bbezel\b|apmal|apvad/i.test(line)) key = 'bezel';
        else if (/\bmovement\b|mehānism|mechanizm/i.test(line)) key = 'movement';
        else if (/\bcrystal\b|stikl/i.test(line)) key = 'crystal';
        else if (/\bdial\b|ciparnīc|ciferblat/i.test(line)) key = 'dial';
        else if (/\bcase\b|korpus/i.test(line) && /bracelet|strap|aproc|siksniņ|apyrank|diržel/i.test(line)) key = 'case_bracelet';
        else if (/\bcase\b|korpus/i.test(line)) key = 'case';
        else if (/bracelet|strap|aproc|siksniņ|apyrank|diržel/i.test(line)) key = 'bracelet';
        add(key, labels[key], line);
      }
      fallback.forEach(row => {
        if (rows.has(row.key)) return;
        if (row.key === 'dial_color' && rows.has('dial')) return;
        if (row.key === 'featuress' && lines.some(line => /display|chronograph|rādījum|hronogrāf|chronograf|rodmuo/i.test(line))) return;
        add(row.key, row.label, row.value);
      });
      const newBody = document.createElement('tbody');
      for (const [key, row] of rows) {
        const tr = document.createElement('tr');
        tr.dataset.specKey = key;
        const th = document.createElement('th');
        th.scope = 'row';
        th.textContent = (row.label || labels.featuress).trim();
        const td = document.createElement('td');
        if (row.values.length === 1) td.textContent = row.values[0];
        else {
          const ul = document.createElement('ul');
          row.values.forEach(value => {
            const li = document.createElement('li');
            li.textContent = value;
            ul.append(li);
          });
          td.append(ul);
        }
        tr.append(th, td);
        newBody.append(tr);
      }
      range.deleteContents();
      heading.remove();
      const storyHeading = [...copy.querySelectorAll('h1,h2,h3,h4,h5,h6,p,strong')].find(el => /^(why you(?:'ll| will) like it|description|apraksts|kāpēc izvēlēties šo modeli|aprašymas):?$/.test(normalize(el.textContent)));
      storyHeading?.remove();
      const additional = [...copy.querySelectorAll('h1,h2,h3,h4,h5,h6,p,strong')].find(el => /^(additional information|papildu informācija|papildoma informacija):?$/.test(normalize(el.textContent)));
      let extra;
      if (additional) {
        const extraRange = document.createRange();
        extraRange.setStartAfter(additional);
        extraRange.setEnd(copy, copy.childNodes.length);
        const extraContent = document.createElement('div');
        extraContent.append(extraRange.cloneContents());
        if (extraContent.textContent.trim()) {
          extra = document.createElement('details');
          extra.className = 'ch-pdp-extra';
          const summary = document.createElement('summary');
          summary.textContent = additional.textContent.trim();
          extraContent.className = 'ch-pdp-description rte';
          extra.append(summary, extraContent);
          extraRange.deleteContents();
          additional.remove();
        }
      }
      for (const tree of [copy, extra].filter(Boolean)) {
        tree.querySelectorAll('div,section,p,span,h1,h2,h3,h4,h5,h6,ul,li').forEach(el => {
          if (el !== extra?.lastElementChild) el.removeAttribute('class');
          el.removeAttribute('style');
          el.removeAttribute('align');
        });
      }
      source.replaceChildren(...copy.childNodes);
      if (!source.textContent.trim() && !source.querySelector('img,video') && !this.querySelector('.ch-pdp-model-intro')) this.querySelector('.ch-pdp-overview').hidden = true;
      table.tBodies[0].replaceWith(newBody);
      this.querySelector('.ch-pdp-specifications').hidden = false;
      if (extra) this.querySelector('.ch-pdp-question').before(extra);
      this.dataset.layout = 'structured';
    }
  }
  customElements.define('chronoera-product-details', ChronoeraProductDetails);
}

(() => {
  if (!/^(lv|lt)(-|$)/.test(document.documentElement.lang)) return;
  const source = document.querySelector('[data-chronoera-product-labels]');
  if (!source) return;
  const labels = JSON.parse(source.textContent);
  const observed = new WeakSet();
  const chat = root => {
    const label = root.querySelector('[data-testid="widgetLabel"] > span');
    if (label?.textContent.trim() === 'Chat with us') {
      const text = [...label.childNodes].find(node => node.nodeType === Node.TEXT_NODE);
      if (text) text.nodeValue = labels.chat + ' ';
    }
    const button = root.querySelector('[data-testid="widgetButtonBody"]');
    if (button?.getAttribute('aria-label') === 'Open chat widget') button.setAttribute('aria-label', labels.open);
  };
  const localize = () => {
    const buy = document.getElementById('buy-me-add-to-cart-btn');
    if (buy?.textContent.trim() === 'Buy Now') buy.textContent = labels.buy;
    document.querySelectorAll('.jdgm-widget label, .jdgm-widget select, .jdgm-widget span').forEach(el => {
      if (!el.children.length && el.textContent.trim() === 'Sort reviews by') el.textContent = labels.sort;
      if (el.getAttribute('aria-label') === 'Sort reviews by') el.setAttribute('aria-label', labels.sort);
    });
    const root = document.getElementById('tidio-chat')?.shadowRoot;
    if (root && !observed.has(root)) {
      observed.add(root);
      new MutationObserver(() => chat(root)).observe(root, {childList:true,subtree:true});
      chat(root);
    }
  };
  new MutationObserver(localize).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('tidioChat-ready', localize);
  localize();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chronoera-prx"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('chronoera-prx-tabs')) {
  customElements.define('chronoera-prx-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('is-ready')) return;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      if (!tabs.length || tabs.length !== panels.length) return;
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      select(0);
      this.classList.add('is-ready');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
